import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export const IndexerStatusCard = ({ status }) => {
  if (!status) return null;
  return (
    <Card className="mt-8" data-testid="indexer-status">
      <CardHeader><CardTitle className="text-lg">Indexer Status</CardTitle></CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-6 mb-6">
          <div className="min-w-0">
            <p className="text-xs sm:text-sm text-muted-foreground mb-1 truncate">Transfer Indexer</p>
            <div className="flex items-center gap-2">
              <div className={`status-dot ${status.indexer_running ? 'online' : 'offline'}`} />
              <span className="font-medium text-sm sm:text-base">{status.indexer_running ? 'Running' : 'Stopped'}</span>
            </div>
          </div>
          <div className="min-w-0">
            <p className="text-xs sm:text-sm text-muted-foreground mb-1 truncate">DEX Indexer</p>
            <div className="flex items-center gap-2">
              <div className={`status-dot ${status.dex_indexer_running ? 'online' : 'offline'}`} />
              <span className="font-medium text-sm sm:text-base">{status.dex_indexer_running ? 'Running' : 'Stopped'}</span>
            </div>
          </div>
          <div className="min-w-0">
            <p className="text-xs sm:text-sm text-muted-foreground mb-1 truncate">Indexed Block</p>
            <p className="font-mono font-medium text-sm sm:text-base truncate">{status.last_indexed_block?.toLocaleString()}</p>
          </div>
          <div className="min-w-0">
            <p className="text-xs sm:text-sm text-muted-foreground mb-1 truncate">Latest Block</p>
            <p className="font-mono font-medium text-sm sm:text-base truncate">{status.latest_block?.toLocaleString()}</p>
          </div>
          <div className="min-w-0">
            <p className="text-xs sm:text-sm text-muted-foreground mb-1">Lag</p>
            <p className={`font-mono font-medium text-sm sm:text-base ${status.lag <= 10 ? 'text-emerald-500' : 'text-amber-500'}`}>{status.lag} blocks</p>
          </div>
          <div className="min-w-0">
            <p className="text-xs sm:text-sm text-muted-foreground mb-1 truncate">Total Txns</p>
            <p className="font-mono font-medium text-sm sm:text-base">{(
              (status.tokens_stats?.KROWN?.total_transfers || 0) +
              (status.tokens_stats?.USDT?.total_transfers || 0) +
              (status.tokens_stats?.ETH?.total_transfers || 0) +
              (status.dex_stats?.total_swaps_indexed || 0)
            ).toLocaleString()}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
